module.exports = __webpack_public_path__ + "assets/img/1682-pr.svg";